import React, { useEffect, useState, } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import PersonIcon from '@material-ui/icons/Person';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '../commons/Button';
import SaveIcon from '@material-ui/icons/Save';


const drawerWidth = 320;
const useStyles = makeStyles((theme) => ({
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    background: '#749474'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
  },
}));

const NavBar = ({
  setOpen,
  open,
  userOpen,
  setUserOpen,
  moveMarkers,
  setModalOpen,
  signOut,
  setShowTutorial,
  saveEvent,
  getImages,
  hasId
}) => {
  const classes = useStyles();

  return (
    <AppBar position="absolute" className={clsx(classes.appBar, (open || userOpen) && classes.appBarShift)}>
    <Toolbar className={classes.toolbar}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="open drawer"
        onClick={() => {setUserOpen(false); setOpen(true)}}
        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
      >
        <MenuIcon />
      </IconButton>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="open drawer"
        onClick={() => {setUserOpen(true); setOpen(false)}}
        className={clsx(classes.menuButton, userOpen && classes.menuButtonHidden)}
      >
        <PersonIcon />
      </IconButton>
      <Button style={{ color: 'white' }} onClick={() => moveMarkers()} title="Center Pins To Map" />
      <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
        Create Your Own Event
      </Typography>
      <Button 
        onClick={() => saveEvent()} 
        title="Save"
        />
    </Toolbar>
  </AppBar>
 )
}

export default NavBar;